import { useTheme } from "@emotion/react";
import { Stack, TextField, Typography } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import React, { useRef, useState } from "react";
import SectionContainer from "components/ai-editor/SectionContainer";
import EditNoteIcon from "@mui/icons-material/EditNote";

export const NOTE_TYPE = {
  key: "note",
  default: {
    text: "",
  },
  icon: <EditNoteIcon />,
};

export default function Note({ section, dragHandleProps }) {
  const theme = useTheme();
  const ref = useRef(null);

  const [saving, setSaving] = useState(false);

  const handleBlur = async () => {
    try {
      setSaving(true);
      await updateDoc(
        doc(db, "documents", section.documentId, "sections", section.id),
        {
          text: ref.current.innerText,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SectionContainer
      section={section}
      dragHandleProps={dragHandleProps}
      saving={saving}
    >
      <Stack
        spacing={2}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          {NOTE_TYPE.icon}
          <Typography>Note</Typography>
        </Stack>
        <Typography
          sx={{
            color: theme.palette.text.main,
          }}
          contentEditable
          suppressContentEditableWarning={true}
          onBlur={handleBlur}
          ref={ref}
        >
          {section.text}
        </Typography>
      </Stack>
    </SectionContainer>
  );
}
